import React, { useEffect, useState } from 'react'
import SanitizeHtml from '../../Base/SanitizeHtml/SanitizeHtml'

const ModalCase2 = ({
  amenitiesDefinitions,
  isOpen,
  master,
  child,
  exemption,
  onSubmit,
  onUndo,
  dictionary,
}) => {
  // const { dictionary } = window.bookingData || window.modifyData
  const [records, setRecords] = useState([])
  const [text, setText] = useState('')

  useEffect(() => {
    setRecords(amenitiesDefinitions)
  }, [])

  useEffect(() => {
    const value1 = `<strong>${childTitle}</strong>`
    const value2 = `<strong>${masterTitle}</strong>`
    const value3 = `<span>${exemption}</span>`

    setText(
      dictionary.modalCase2Text
        .replace('{0}', value1)
        .replace('{1}', value2)
        .replace('{2}', value3)
    )
  }, [childTitle, masterTitle, exemption, dictionary])

  const masterTitle = records.find((i) => i.code === master)?.name || ''
  const childTitle = records.find((i) => i.code === child)?.name || ''

  const iconImage = () => {
    return master
      ? amenitiesDefinitions.find((i) => i.code === master).image
      : ''
  }

  const onClickUndo = () => onUndo(child)

  const onClickSubmit = () => onSubmit(master, child)

  return (
    <div
      id="modalCase2"
      className={`modal s-modal s-modal--warning  ${
        isOpen ? 'show d-block' : ''
      }`}
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
      role="dialog">
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <div className="modal-title">
              {iconImage() && (
                <div>
                  {/* <i className="icon-warning"></i> */}
                  <img src={iconImage().url} alt={iconImage().alt} />
                </div>
              )}
              <div>{dictionary.modalCase2Title}</div>
            </div>
          </div>
          <div className="modal-body">
            <div>
              <SanitizeHtml tag="p" html={text} />
            </div>
          </div>
          <div className="modal-footer">
            <ul>
              <li>
                <button
                  type="button"
                  className="btn btn-outline-primary"
                  onClick={onClickUndo}
                  title={dictionary.modalCase2ButtonUndoText}>
                  {dictionary.modalCase2ButtonUndoText}
                </button>
              </li>
              <li>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={onClickSubmit}
                  title={dictionary.modalCase2ButtonSubmitText}>
                  {dictionary.modalCase2ButtonSubmitText}
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModalCase2
